import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'lib-accordeon-item-header',
  template: '<ng-template><ng-content></ng-content></ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordeonItemHeaderComponent {
  @ViewChild(TemplateRef) private set _contentRef(value: TemplateRef<any>) {
    this.contentRef$.next(value);
  }

  public contentRef$ = new ReplaySubject<TemplateRef<any>>(1);
}
